/**
 * Отчёт «Аналитики» вкладками: заголовок `# …` — заголовок страницы, текст до первого `## …` — вступление
 * над вкладками, каждый `## …` — вкладка. `##` внутри блока кода (```) не режет. Без React — тестируется node:test.
 */

export type ReportTabs = { title: string | null; intro: string; tabs: { title: string; body: string }[] };

export function splitTabs(markdown: string): ReportTabs {
  let title: string | null = null;
  const intro: string[] = [];
  const tabs: { title: string; lines: string[] }[] = [];
  let fence = false;
  for (const line of markdown.split("\n")) {
    if (line.trimStart().startsWith("```")) fence = !fence;
    if (!fence && title === null && tabs.length === 0 && line.startsWith("# ")) {
      title = line.slice(2).trim();
      continue;
    }
    if (!fence && line.startsWith("## ")) {
      tabs.push({ title: line.slice(3).trim(), lines: [] });
      continue;
    }
    (tabs.length ? tabs[tabs.length - 1]!.lines : intro).push(line);
  }
  return {
    title,
    intro: intro.join("\n").trim(),
    tabs: tabs.map((t) => ({ title: t.title, body: t.lines.join("\n").trim() })),
  };
}

/** Номер вкладки из адреса (`?tab=`): нет, не число или вне диапазона — первая. */
export function tabIndex(raw: string | null, count: number): number {
  const n = raw === null ? NaN : Number(raw);
  return Number.isInteger(n) && n >= 0 && n < count ? n : 0;
}
